import React from "react";
import { PaginationInterface, Params } from "../Util/Interface";
import { defaultPageOptions } from "../Util/Constant";

export default function Style1({
  params,
  updateParams = () => undefined,
  paginationPlacement = "right",
  paginationWrapperClass = "",
  prevText = "",
  nextText = "",
  prevIcon = null,
  nextIcon = null,
  paginationButtonClass = "",
  pageOptions = defaultPageOptions,
}: PaginationInterface) {
  const [mainParams, setMainParams] = React.useState<Params>(
    params || { page: 1, per_page: 25, total: 1 }
  );

  const getPages = React.useCallback((c: number, t: number) => {
    const pages: (number | string)[] = [];
    if (t <= 7) {
      for (let i = 1; i <= t; i++) pages.push(i);
    } else {
      if (c <= 4) {
        for (let i = 1; i <= 5; i++) pages.push(i);
        pages.push("...", t);
      } else if (c >= t - 3) {
        pages.push(1, "...");
        for (let i = t - 4; i <= t; i++) pages.push(i);
      } else {
        pages.push(1, "...", c - 1, c, c + 1, "...", t);
      }
    }
    return pages;
  }, []);

  const goTo = React.useCallback(
    (page: number) => {
      if (page >= 1 && page <= (mainParams?.total ?? 1)) {
        const newParams = { ...mainParams, page };

        setMainParams(newParams);
        updateParams(newParams);
      }
    },
    [mainParams, updateParams]
  );

  React.useEffect(() => {
    if (params) setMainParams(params);
  }, [params]);

  const pages = getPages(mainParams?.page ?? 1, mainParams?.total ?? 1);

  return (
    <div
      className={`pagination__container-s1 ${paginationWrapperClass}`}
      style={{ justifyContent: paginationPlacement }}
    >
      <div className="style1__pagination-per_page">
        <label>
          {pageOptions.find((p) => p.value === mainParams.per_page)?.label}
        </label>
        <ul>
          {pageOptions.map((p, i) => (
            <li
              key={i}
              onClick={() =>
                updateParams({ ...mainParams, page: 1, per_page: p.value })
              }
            >
              {p.label}
            </li>
          ))}
        </ul>
      </div>
      <div className={`style1__pagination`}>
        <button
          className={`pagination__button_s1 ${paginationButtonClass}`}
          onClick={() => goTo((mainParams?.page ?? 1) - 1)}
          disabled={mainParams.page === 1}
        >
          {`${prevText} ${prevIcon || "←"}`}
        </button>

        {pages.map((p, i) =>
          p === "..." ? (
            <button
              key={i}
              className={`pagination__button_s1 dots ${paginationButtonClass}`}
              disabled
            >
              ...
            </button>
          ) : (
            <button
              key={i}
              className={`pagination__button_s1 ${
                p === mainParams.page ? "active" : ""
              } ${paginationButtonClass}`}
              onClick={() => goTo(p as number)}
            >
              {p}
            </button>
          )
        )}

        <button
          className={`pagination__button_s1 ${paginationButtonClass}`}
          onClick={() => goTo((mainParams?.page ?? 1) + 1)}
          disabled={mainParams.page === mainParams.total}
        >
          {`${nextText} ${nextIcon || "→"}`}
        </button>
      </div>
    </div>
  );
}
